
import {InvestFor} from "./invest-for";
import {PersonalInfo} from "./personal-info";
import {SourceOfFunds} from "./source-of-funds";
import {Employment} from "./employment";
import {NetWorth} from "./net_worth";
import {Identification} from "./identification";
import {Authorization_0} from "./authorization-0";
import {FinraAffiliation} from "./finra-affiliation";
import {Risk_1} from "./risk_1";
import {Risk_2} from "./risk_2";
import {Summary} from "./summary/summary";
import {SigningDone} from "../onboarding-shared/signing-done";
import {PaymentSource} from "../onboarding-shared/payment-source";
import {Payment} from "../onboarding-shared/payment";
import {FlowRender} from "../flow-render";
import React from "react";
import {TrustedContact} from "./trusted_contact";
import {Crypto} from "./crypto";
import {TaxAttestation} from "./tax-attestation";
import {AccountTransfer} from "./account-transfer";
import {Risk_0} from "./risk_0";

class PathUndefined extends FlowRender {

  constructor() {
    super([]);
  }

  renderContent = url => {
    const text = "Undefined endpoint - " + url;
    return (
      <div>
        <div style={{fontSize: "2.5rem"}}>{text}</div>
      </div>
    );
  };

  render = (component) => {
    return (
      <div style={{height: "20rem"}}>
      </div>
    );
  }
}


const mk_index = (index, total) => {
  return { index, total };
};

const total = 16;

const SchwabFlowMap = {
  invest_for: new InvestFor(mk_index(1, total)),
  account_transfer: new AccountTransfer(mk_index(2, total)),
  personal_info: new PersonalInfo(mk_index(3, total)),
  source_of_funds: new SourceOfFunds(mk_index(4, total)),
  employment: new Employment(mk_index(5, total)),
  net_worth: new NetWorth(mk_index(6, total)),
  identification: new Identification(mk_index(7, total)),
  trusted_contact: new TrustedContact(mk_index(8, total)),
  authorization_0: new Authorization_0(mk_index(9, total)),
  finra_affiliation: new FinraAffiliation(mk_index(10, total)),
  risk_0: new Risk_0(mk_index(11, total)),
  risk_1: new Risk_1(mk_index(12, total)),
  risk_2: new Risk_2(mk_index(13, total)),
  crypto: new Crypto(mk_index(14, total)),
  tax_attestation: new TaxAttestation(mk_index(15, total)),
  summary: new Summary(),
  signing_done: new SigningDone(),
  payment_source: new PaymentSource(),
  payment: new Payment({
    go_live_on_payment: true,
  }),
}

export { SchwabFlowMap, PathUndefined };
